import React, { useState, useEffect, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { getUsersAnalytics, getUsersCount } from "../../api/WebpageDashboardApi";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import Table from "../../views/Table";
import { setCompanyUserLoading } from "ReduxStore/Slices/companyUserSlice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

import {GET, POST} from 'api/API'

const SessionsUsersList = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [noOfDays, setnoOfDays] = useState(7);

  const [isAdmin, setIsAdmin] = useState(false);

  const { companyUserLoading } = useSelector(
    (state) => state.companyUserSetter
  );
  const { role, companyType } = useSelector(state => state.userSetter)

  const dispatch = useDispatch();
  
  function updateRole() {
    let t = localStorage.getItem('role');
    setIsAdmin(t === 'admin');
  }

  
  
  useEffect(() => {
    dispatch(setCompanyUserLoading(true));
    updateRole( );
  }, []);


  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    const startRow = pageSize * pageIndex;
    var url_string = window.location.href;
    var url = new URL(url_string);
    var noOfDaysV = url.searchParams.get("noOfDays");
    setnoOfDays(noOfDaysV);
    setPageIndex(pageIndex);

    getUsersCount(noOfDaysV).then(data => {
      setPageCount(Math.ceil(data.count / pageSize));
      setTotal(data.count);
    })
    getUsersAnalytics(noOfDaysV, pageSize, startRow).then((temp) => {
      let data = [];
      let count = 0;
      temp.forEach((t) => {
        let ipA = t.ipAddress ? t.ipAddress.slice(0, 3) : [];
        ipA = ipA.join('   ,   ')
        let u = {
          personId: t.person && t.person.length ? t.person[0]._id : '',
          email: t.person && t.person.length ? t.person[0].email : '.',
          lastName: t.person && t.person.length ? t.person[0].lastName : '.',
          firstName: t.person && t.person.length ? t.person[0].firstName : '.',
          viewCount: t.viewCount,
          clickCount: t.clickCount,
          ipAddress: ipA,
          lastVisit: t.lastVisit,
          zipCode : t.zipcode && t.zipcode.length ? t.zipcode[0]: '',
          city : t.city && t.city.length ? t.city[0]: '',
          country : t.country && t.country.length ? t.country[0]: '',
          region : t.region && t.region.length ? t.region[0]: '',
          matchStatus : t.matchStatus ? t.matchStatus : '',
          amount : t.leadGenRevenue ? '$'+Number.parseFloat(t.leadGenRevenue).toFixed(2) : '',
          date : t.createdAt ? t.createdAt : '',
          comment : t.comment ? t.comment : '',
        };
        data.push(u);
        count++;
      });
      setDataApi(data);
      dispatch(setCompanyUserLoading(false));
    });
  }, []);

  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () => role== 'publisher'? [
      {

        Header: "Email",
        accessor: "email",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {

        Header: "Zip Code",
        accessor: "zipCode",
      },

      {

        Header: "City",
        accessor: "city",
      },
      {

        Header: "Region",
        accessor: "region",
      },

      {

        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Match Status",
        accessor: "matchStatus",
      },
      {
        Header: "Rev-share Amount",
        accessor: "amount",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Comment",
        accessor: "comment",
      },
      
      {

        Header: "IP Address",
        accessor: "ipAddress",
      },
      {

        Header: "Click Count",
        accessor: "clickCount",
      },
      {
        Header: "View Count",
        accessor: "viewCount",
      },
      {
        Header: "Last Visit",
        accessor: "lastVisit",
      },
    ]: companyType=='lead'?[
      {

        Header: "Email",
        accessor: "email",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {

        Header: "Zip Code",
        accessor: "zipCode",
      },

      {

        Header: "City",
        accessor: "city",
      },
      {

        Header: "Region",
        accessor: "region",
      },

      {

        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Match Status",
        accessor: "matchStatus",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Comment",
        accessor: "comment",
      },
      
      {

        Header: "IP Address",
        accessor: "ipAddress",
      },
      {

        Header: "Click Count",
        accessor: "clickCount",
      },
      {
        Header: "View Count",
        accessor: "viewCount",
      },
      {
        Header: "Last Visit",
        accessor: "lastVisit",
      },
    ]:[
      {

        Header: "Email",
        accessor: "email",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {

        Header: "Zip Code",
        accessor: "zipCode",
      },

      {

        Header: "City",
        accessor: "city",
      },
      {

        Header: "Region",
        accessor: "region",
      },

      {

        Header: "Country",
        accessor: "country",
      },
      
      {

        Header: "IP Address",
        accessor: "ipAddress",
      },
      {

        Header: "Click Count",
        accessor: "clickCount",
      },
      {
        Header: "View Count",
        accessor: "viewCount",
      },
      {
        Header: "Last Visit",
        accessor: "lastVisit",
      },
    ],
    []
  );

  return (
    <Container>
      <div className="page_heading">
        <h2>Users List</h2>
        <button
          className="btn btn-sm"
          style={{ color: "#114169" }}
          onClick={() => props.history.push(`/admin/dashboard`)}
        >{`< Back`}</button>
        <p className="sm d-flex align-items-center">
          You have {total} users through {noOfDays} days.
          <span className="inline-label ml-auto">
            Page No. {pageIndex + 1} of {pageCount}
          </span>
        </p>
      </div>

        
            <div style={{display: 'flex', alignItems:"flex-end", padding:"10px"}}>
            {isAdmin &&<input
              onClick={(e) =>{
                GET(`export/sessions?noOfDays=${noOfDays}&isusers=true`).then((data) => {
                  toast.success("Exported Successfully");
                }).catch((error) => {
                  toast.error("Export Failed");
                });

              }}
              type="submit"
              name="Save"
              // style={{
              //   margin_top: "2v",
              //   cursor: "pointer",
              //   borderRadius: "6px",
              //   padding: "0px",
              //   minWidth: "90px",
              //   fontSize: "13px",
              //   margin: "0 12px",
              //   height: "32px"
              // }}
              className="add__stage lg_btn primary"
              value="Export"
              style={{margin:"0 auto"}}
            />}
            </div>
     
      <div></div>
      {dataApi ? (
        <div id="usersListTable">
          {
            <Table
              columns={columns}
              data={data}
              pageCount={pageCount}
              fetchData={fetchData}
              loading={companyUserLoading}
              onRowClick = {(e,person) =>{
                if(person.personId){
                  window.open(`/admin/contact/details?id=${person.personId}`, '_blank').focus();

                }else{ 
                  toast.info("Unidentified Accounts can't be viewed");
                }
              }}
            ></Table>
          }
        </div>
      ) : (
        <ContactLoader />
      )}
    </Container>
  );
};

export default SessionsUsersList;
